// 小さな線の絵（SVG）。文字と同じ色・大きさで出る。
// 左のメニューとカテゴリーの札では、角丸の四角（アプリのアイコンの形）の上にピンクの太い線で出す（appful のトーン。iconTile）。
const NS = "http://www.w3.org/2000/svg";

const PATHS = {
  play: "M8 5.5v13l11-6.5z",
  clock: "M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18zm0 4.5v5l3.2 2",
  check: "M4.5 12.5l5 5 10-11",
  back: "M14.5 5l-7 7 7 7",
  full: "M4 9V4h5M15 4h5v5M20 15v5h-5M9 20H4v-5",
  trophy: "M7 4h10v5a5 5 0 0 1-10 0zM7 6H4v1a3 3 0 0 0 3 3M17 6h3v1a3 3 0 0 1-3 3M12 14v4M8.5 20h7",
  search: "M10.5 4a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13zM15.5 15.5L20 20",
  home: "M4 11l8-7 8 7v9h-5v-6H9v6H4z",
  user: "M12 4a4 4 0 1 0 0 8 4 4 0 0 0 0-8zM4.5 20a7.5 7.5 0 0 1 15 0",
  sound: "M4 9.5h3.5L12 6v12l-4.5-3.5H4zM15.5 9a4 4 0 0 1 0 6M18 6.5a7.5 7.5 0 0 1 0 11",
  mute: "M4 9.5h3.5L12 6v12l-4.5-3.5H4zM15.5 9.5l5 5M20.5 9.5l-5 5",
  resume: "M5 5v14M9 5.5v13l10-6.5z",
  // カテゴリー（すべて・1分・種類・教科）
  all: "M4.5 4.5h6v6h-6zM13.5 4.5h6v6h-6zM4.5 13.5h6v6h-6zM13.5 13.5h6v6h-6z",
  quick: "M12 21a8 8 0 1 0 0-16 8 8 0 0 0 0 16zM12 9v4l2.5 1.5M10 2.5h4M12 2.5V5",
  casual: "M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18zM8.5 14a4 4 0 0 0 7 0M9 9.5h.01M15 9.5h.01",
  action: "M13 2.5L5 13.5h6l-1 8 8-11h-6z",
  puzzle: "M10 4.5a2 2 0 1 1 4 0V6h4v4h-1.5a2 2 0 1 0 0 4H18v4h-4v-1.5a2 2 0 1 0-4 0V18H6v-4h1.5a2 2 0 1 0 0-4H6V6h4z",
  mystery: "M10.5 4a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13zM15.5 15.5L20 20M9 9a1.6 1.6 0 1 1 2.3 1.4c-.5.3-.8.6-.8 1.1M10.5 13.6h.01",
  sports: "M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18zM6 5.8c1.9 1.7 3 3.7 3 6.2s-1.1 4.5-3 6.2M18 5.8c-1.9 1.7-3 3.7-3 6.2s1.1 4.5 3 6.2",
  racing: "M5.5 21V4M5.5 4.5h12l-2.5 4 2.5 4h-12",
  arcade: "M7.5 8h9a4.5 4.5 0 0 1 4.5 4.5v.5a3.5 3.5 0 0 1-6.4 2L14 14h-4l-.6 1A3.5 3.5 0 0 1 3 13v-.5A4.5 4.5 0 0 1 7.5 8zM8 10.5v3M6.5 12h3M15.5 11h.01M17.5 13h.01",
  simulation: "M12 21v-8.5M12 12.5c0-4 2.8-6.5 7-6.5 0 4-2.8 6.5-7 6.5zM12 15c0-3-2.4-5-6-5 0 3 2.4 5 6 5z",
  strategy: "M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18zM12 7.5a4.5 4.5 0 1 0 0 9 4.5 4.5 0 0 0 0-9zM12 11.9v.2",
  learning: "M4 5.5C6.5 4.5 9.5 4.6 12 6.2c2.5-1.6 5.5-1.7 8-.7V19c-2.5-1-5.5-.9-8 .7-2.5-1.6-5.5-1.7-8-.7zM12 6.2v13.5",
  other: "M12 3.5l1.7 4.8 4.8 1.7-4.8 1.7L12 16.5l-1.7-4.8L5.5 10l4.8-1.7zM18 15.5l.7 1.8 1.8.7-1.8.7-.7 1.8-.7-1.8-1.8-.7 1.8-.7z",
  math: "M7 4.5v6M4 7.5h6M14 7.5h6M5 15l4 4M9 15l-4 4M14 15.5h6M14 18.5h6",
  japanese: "M15.5 4.5l4 4L9 19H5v-4zM13.5 6.5l4 4",
  social: "M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18zM3.5 12h17M12 3c2.4 2.5 3.7 5.5 3.7 9s-1.3 6.5-3.7 9c-2.4-2.5-3.7-5.5-3.7-9S9.6 5.5 12 3z",
  science: "M9 3.5h6M10 3.5v5.5L4.8 18.3A1.8 1.8 0 0 0 6.4 21h11.2a1.8 1.8 0 0 0 1.6-2.7L14 9V3.5M7.2 15h9.6",
  english: "M4 5h16v11H9.5L5 20v-4H4zM9.3 13.5l2.7-6 2.7 6M10.2 11.5h3.6",
  info: "M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18zM12 11v5.5M12 7.6h.01",
} as const;

export type IconName = keyof typeof PATHS;

export function icon(name: IconName): SVGSVGElement {
  const svg = document.createElementNS(NS, "svg");
  svg.setAttribute("viewBox", "0 0 24 24");
  svg.setAttribute("class", "ic");
  svg.setAttribute("aria-hidden", "true");
  svg.setAttribute("fill", name === "play" ? "currentColor" : "none");
  svg.setAttribute("stroke", "currentColor");
  svg.setAttribute("stroke-width", "2");
  svg.setAttribute("stroke-linecap", "round");
  svg.setAttribute("stroke-linejoin", "round");
  const path = document.createElementNS(NS, "path");
  path.setAttribute("d", PATHS[name]);
  svg.append(path);
  return svg;
}

/** アプリのアイコンの形（角丸の四角）にピンクの線の絵。色は使う場所の CSS で決める（選んでいる物だけピンクの地に白） */
export function iconTile(name: IconName): HTMLElement {
  const el = document.createElement("span");
  el.className = "itile";
  el.setAttribute("aria-hidden", "true");
  el.append(icon(name));
  return el;
}

/** カテゴリーの札の id（all・quick・genre:x・subject:x）から絵を選ぶ */
export function categoryIcon(id: string): IconName {
  const key = id.includes(":") ? id.slice(id.indexOf(":") + 1) : id;
  return key in PATHS ? (key as IconName) : "other";
}
